export const enum SNACK_ACTION {
    ERROR = 'snackbar/error',
    WARNING = 'snackbar/warning',
    SUCCESS = 'snackbar/success',
    CLEAR = 'snackbar/clear',
}

export const enum SNACK_TYPE {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
}

export interface ISnackBarState {
    on: boolean;
    type: SNACK_TYPE;
    message: string;
}

const state: ISnackBarState = {
    on: false,
    type: SNACK_TYPE.SUCCESS,
    message: "",
};

const actions = {
    error: ({ commit }: any, message: string) => {
        commit('error', message);
    },

    warning: ({ commit }: any, message: string) => {
        commit('warning', message);
    },

    success: ({ commit }: any, message: string) => {
        commit('success', message);
    },

    clear: ({ commit }: any) => {
        commit('clear');
    },
};

const mutations = {
    error(newState: ISnackBarState, message: string) {
        newState.type = SNACK_TYPE.ERROR;
        newState.message = message;
        newState.on = true;
    },

    warning(newState: ISnackBarState, message: string) {
        newState.type = SNACK_TYPE.WARNING;
        newState.message = message;
        newState.on = true;
    },

    success(newState: ISnackBarState, message: string) {
        newState.type = SNACK_TYPE.SUCCESS;
        newState.message = message;
        newState.on = true;
    },

    clear(newState: ISnackBarState) {
        newState.on = false;
    },
};

export const snackbar = {
    namespaced: true,
    state,
    actions,
    mutations,
};
